import i18n from 'config/i18n';
import dayjs, { Dayjs } from 'dayjs';
import { ProjectParticipantResponse } from 'generated/index';
import * as yup from 'yup';

import { getLocale } from 'utils/date';

const t = i18n.getFixedT(getLocale(), 'common');

export const participantSchema = yup.object({
  id: yup.string().notRequired(),
  employee: yup
    .mixed<ProjectParticipantResponse>()
    .required(t('validationFieldRequired', { name: t('employee') })),
  role: yup
    .string()
    .required(t('validationFieldRequired', { name: t('role') })),
  validFrom: yup
    .mixed<Dayjs>()
    .test(
      'dayjs-valid',
      () => t('invalidDate'),
      (v) => {
        if (dayjs.isDayjs(v)) {
          return v.isValid();
        }

        return dayjs(v).isValid();
      }
    )
    .required(t('validationFieldRequired', { name: t('validFrom') })),
  validTo: yup
    .mixed<Dayjs>()
    .test(
      'dayjs-valid',
      () => t('invalidDate'),
      (v) => {
        if (dayjs.isDayjs(v)) {
          return v.isValid();
        }

        return dayjs(v).isValid();
      }
    )
    .required(t('validationFieldRequired', { name: t('validTo') }))
});

export const addEditProjectSchema = yup.object({
  name: yup
    .string()
    .required(t('validationFieldRequired', { name: t('name') })),
  description: yup.string().notRequired(),
  validFrom: yup
    .mixed<Dayjs>()
    .test(
      'dayjs-valid',
      () => t('invalidDate'),
      (v) => {
        return v ? v.isValid() : false;
      }
    )
    .required(t('validationFieldRequired', { name: t('validFrom') })),
  validTo: yup
    .mixed<Dayjs>()
    .test(
      'dayjs-valid',
      () => t('invalidDate'),
      (v) => {
        return v ? v.isValid() : false;
      }
    )
    .required(t('validationFieldRequired', { name: t('validTo') })),
  participants: yup.lazy((arr) => {
    if (!arr || arr?.length === 0) {
      return yup.array();
    }

    return yup.array().of(participantSchema);
  })
});
